// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2akQG","item":"PaymentsMobile_item__15bUW","label":"PaymentsMobile_label__gSB9O","amount":"PaymentsMobile_amount__3guOe"};